import { render } from "./tixian2.vue?vue&type=template&id=38ca0481&scoped=true"
import script from "./tixian2.vue?vue&type=script&lang=js"
export * from "./tixian2.vue?vue&type=script&lang=js"

import "./tixian2.vue?vue&type=style&index=0&id=38ca0481&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Administrator\\Desktop\\记录\\2508幸运28\\xingyun_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38ca0481"]])

export default __exports__